import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=394a77a8&scoped=true"
import script from "./Security.vue?vue&type=script&lang=js"
export * from "./Security.vue?vue&type=script&lang=js"
import style0 from "../assets/css/security.css?vue&type=style&index=0&id=394a77a8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a77a8",
  null
  
)

export default component.exports